// @snippet
/**
 * @class LazyloadHelper
 */
class LazyloadHelper {
  constructor() {}
  static load(element) {
    const sourcesElem = element.querySelectorAll("source");
    const imgElem = element.querySelector("img");
    //

    if (!imgElem && sourcesElem.length === 0) {
      return false;
    }
    element.dataset.imageState = "loading";
    //
    imgElem.onload = LazyloadHelper.onload.bind(this, imgElem, element);
    //
    imgElem.onerror = LazyloadHelper.onerror.bind(this, imgElem, element);
    //
    if (sourcesElem.length > 0) {
      LazyloadHelper.setPictures(sourcesElem);
      LazyloadHelper.setImage(imgElem);
    } else {
      LazyloadHelper.setImage(imgElem);
    }
  }

  static onload(imgElem, picElem) {
    picElem.dataset.imageState = "complete";
    //
    // if (typeof this.callback === "function") {
    //     this.callback(imgElem);
    // }
  }

  static onerror(imgElem, picElem) {
    picElem.dataset.imageState = "error";
    imgElem.dataset.imageState = "error";
    console.error("Nie udało się załadować obrazka", imgElem.src);
  }

  static setPictures(sources) {
    Array.prototype.forEach.call(sources, (source) => {
      // const extension = source.dataset.srcset.substr(
      //     source.dataset.srcset.lastIndexOf(".") + 1
      // );
      // if (this.webp && extension !== "svg") {
      //     source.setAttribute(
      //         "srcset",
      //         source.dataset.srcset.replace("." + extension, ".webp")
      //     );
      // } else {

      source.setAttribute("srcset", source.dataset.srcset);
      // }
    });
  }

  static setImage(image) {
    // const extension = image.srcset ? image.srcset.substr(image.srcset.lastIndexOf(".") + 1) : image.dataset.src.substr(image.dataset.src.lastIndexOf(".") + 1);
    // if (this.webp && extension !== "svg") {
    //     image.setAttribute(
    //         "src",
    //         image.srcset ? image.srcset.replace("." + extension, ".webp") :  image.dataset.src.replace("." + extension, ".webp")

    //     );
    // } else {
    if (image.dataset.srcset) {
      image.setAttribute("srcset", image.dataset.srcset);
    }
    if (image.dataset.src) {
      image.setAttribute("src", image.dataset.src);
    }
    // image.setAttribute("src", image.srcset ? image.srcset : image.dataset.src);
    // }
  }

  static checkVerticalAndHorizontal(params) {
    const picElem =
      typeof params === "object" && params.el ? params.el : params;
    const offsetY = (typeof params === "object" && params.offsetY) || 300;
    const offsetX = (typeof params === "object" && params.offsetX) || 300;

    // console.log('picElem', picElem, typeof options);
    const bounding = picElem.getBoundingClientRect();
    const picElemHeight = picElem.offsetHeight;
    const picElemWidth = picElem.offsetWidth;
    // console.log('bounding', bounding.top + offsetY, picElemHeight);
    if (
      bounding.top + offsetY >= -picElemHeight &&
      bounding.left + offsetX >= -picElemWidth &&
      bounding.right - offsetX <=
        (window.innerWidth || document.documentElement.clientWidth) +
          picElemWidth &&
      bounding.bottom - offsetY <=
        (window.innerHeight || document.documentElement.clientHeight) +
          picElemHeight
    ) {
      return true;
    }
    return false;
  }
}
export default LazyloadHelper;
